import Subject from './subject';
export default class BehaviorSubject extends Subject {
    constructor(initialValue) {
        super();
        this.currentValue = initialValue;
        this.subscribe(() => { });
    }
}
//# sourceMappingURL=behavior-subject.js.map